import type { IUser } from '@manager/api/types/auth-types';
import { buildModalRoute } from '@manager/modules/modals/routable/modal-routable-utils';
import { routeNames } from '@manager/router/route-names';
import type { RouteMetaConfig } from '@manager/types/router';

/** Super admins pass every permission check, yet the API refuses them on every template route. */
export function canOpenDocumentTemplates(user: IUser): boolean {
  const hasKinnovisInvoicing =
    user.tenant_features.uses_kinnovis_invoicing ||
    user.tenant_features.kinnovis_invoicing_set_up;

  return (
    hasKinnovisInvoicing &&
    !user.roles.some((role) => role.name === 'super_admin')
  );
}

export const documentTemplatesRoutes: RouteMetaConfig[] = [
  {
    name: routeNames.documentTemplateList,
    path: '/document-templates',
    component: () =>
      import('@manager/modules/document-templates/views/DocumentTemplateListView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'document_templates.view',
      additionalCheck: canOpenDocumentTemplates,
    },
    children: [
      buildModalRoute(
        {
          name: routeNames.documentTemplateEdit,
          path: ':templateId(\\d+)/edit',
          meta: {
            requiresAuth: true,
            permission: 'document_templates.update',
          },
          component: () =>
            import('@manager/modules/document-templates/views/DocumentTemplateEditorView.vue'),
        },
        { fullscreen: true }
      ),
    ],
  },
];
